export const RELATIVE_PERFORMANCE_CHART_CATEGORY_KEY = 'charting' as const;
export const RELATIVE_PERFORMANCE_CHART_COMPONENT_KEY = 'relativePerformanceChart' as const;
